<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>Brak uprawnień</h2>
        <h3>Nie masz uprawnień do przeglądania tej strony</h3>
        <p>Jeżeli uważasz, że to błąd - skontaktuj się z administratorem systemu.</p>
        <d-button pill @click="goBack">
          <i class="material-icons">arrow_back</i>
          Wróć
        </d-button>
      </div>
    </div>
  </d-container>
</template>

<script>
export default {
  name: 'no-permissions',
  methods: {
    goBack() {
      window.history.go(-2);
    }
  }
}
</script>
